import styled from 'styled-components';

export default styled.td`
  opacity: 0.5;
  color: #c5cede;
  vertical-align: top;
`;
